import React from "react"
import classNames from "classnames"

interface IProps {
  hasDarkBackground?: boolean
}

const LiveMeetingAssetsContainer: React.FC<IProps> = ({hasDarkBackground = false, children}): JSX.Element => {
  return (
    <div className={classNames(
      "flex flex-col flex-1 p-2 overflow-hidden",
      {
        "bg-ch-gray-200": hasDarkBackground
      }
    )}>
      { children }
    </div>
  )
}

export default LiveMeetingAssetsContainer
